module.exports = import("/activity-right-panel-ui/remoteEntry.js");